import React from "react";
import LogementDisplay from "../components/Logement";

const Logement = () => {
  return (
    <div className="logement">
      <main>
        <LogementDisplay />
      </main>
    </div>
  );
};

export default Logement;